import { hideBenefitsOutsideOverview } from "./benefitsVisibility";
import {
  installEmployeeFormTabs,
  installEmployeeTabStyles,
} from "./employeeTabs";
import { mutationContainsEmployeeModal } from "./employeeModalDetection";
import {
  applyAuthoritativeFinanceValues,
  resetFinanceSummary,
} from "./financeForecast";
import { openEmployeeFilePreview } from "./filePreview";
import { improveEmployeeFileTrashLabels } from "./trashLabels";
import { normalizeText } from "./domUtils";

export const synchronizeHumanResourcesEnhancements = () => {
  installEmployeeTabStyles();
  installEmployeeFormTabs();
  hideBenefitsOutsideOverview();
  improveEmployeeFileTrashLabels();
  void applyAuthoritativeFinanceValues();
};

let synchronizationScheduled = false;
const scheduleSynchronization = () => {
  if (synchronizationScheduled) return;
  synchronizationScheduled = true;
  const run = () => {
    synchronizationScheduled = false;
    synchronizeHumanResourcesEnhancements();
  };
  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(run);
  } else {
    window.setTimeout(run, 0);
  }
};

const scheduleSynchronizationAfterInteraction = () => {
  scheduleSynchronization();
  window.setTimeout(scheduleSynchronization, 0);
};

export const routeCanContainEnhancements = () => {
  const location = normalizeText(
    `${window.location?.pathname || ""} ${window.location?.hash || ""}`,
  );
  return (
    location.includes("human") ||
    location.includes("recursos") ||
    location.includes("finance") ||
    location.includes("financeiro") ||
    location.includes("trash") ||
    location.includes("lixeira") ||
    location.includes("config")
  );
};

const start = () => {
  if (window.__humanResourcesEnhancementsStarted) return;
  window.__humanResourcesEnhancementsStarted = true;
  synchronizeHumanResourcesEnhancements();

  document.addEventListener(
    "click",
    (event) => {
      const anchor = event.target?.closest?.("a");
      if (anchor) void openEmployeeFilePreview(anchor, event);
      if (event.target?.closest?.("button")) {
        scheduleSynchronizationAfterInteraction();
      }
    },
    true,
  );

  window.addEventListener("focus", () => {
    resetFinanceSummary();
    scheduleSynchronization();
  });

  const observerRoot = document.body || document.getElementById("root");
  if (!observerRoot) return;
  window.__humanResourcesEnhancementsObserver?.disconnect?.();
  const observer = new MutationObserver((records) => {
    if (
      routeCanContainEnhancements() ||
      mutationContainsEmployeeModal(records)
    ) {
      scheduleSynchronization();
    }
  });
  observer.observe(observerRoot, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["disabled"],
  });
  window.__humanResourcesEnhancementsObserver = observer;
};

if (typeof window !== "undefined" && typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
}
